module.exports = __webpack_public_path__ + "img/title-right1.db9134c.png";